/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetRiskPolicyChallengeResponseBody = {
  /**
   * Whether this challenge has already been acknowledged.
   */
  acknowledged: boolean;
  /**
   * RFC3339 time the acknowledgement link expires.
   */
  expiresAt?: Date | undefined;
  /**
   * Human-facing challenge message describing what was flagged.
   */
  message: string;
  /**
   * The policy that issued the warning.
   */
  policyName?: string | undefined;
  /**
   * The tool the challenge applies to, if any.
   */
  toolName?: string | undefined;
};

/** @internal */
export const GetRiskPolicyChallengeResponseBody$inboundSchema: z.ZodMiniType<
  GetRiskPolicyChallengeResponseBody,
  unknown
> = z.pipe(
  z.object({
    acknowledged: z.boolean(),
    expires_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    message: z.string(),
    policy_name: z.optional(z.string()),
    tool_name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_at": "expiresAt",
      "policy_name": "policyName",
      "tool_name": "toolName",
    });
  }),
);

export function getRiskPolicyChallengeResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetRiskPolicyChallengeResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetRiskPolicyChallengeResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetRiskPolicyChallengeResponseBody' from JSON`,
  );
}
